import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import axios from "axios";
import React, { useEffect, useState } from "react";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "./OpenBets.css";

function OpenBets(props) {
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [openBets, setOpenBets] = React.useState([]);
  const [color, setColor] = useState("#00FFFF");

  const handleChangeColor = (event) => {
    setColor(event.target.value);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      GetGameTypes();
    }, 2500);
    return () => clearTimeout(interval);
  }, [openBets]);

  const GetGameTypes = () => {
    // Change for server api address
    const url =
      process.env.REACT_APP_API2_URL + "/BetTicker/GetOpenBets?limit=100";
    axios({
      method: "get",
      url: url,
      /*  REPLACE WITH SELECT DATA */
    }).then((response) => {
      setOpenBets(response.data);
    });
  };

  const options = {
    page: 1, // which page you want to show as default
    sizePerPageList: [
      {
        text: "15",
        value: 15,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ], // you can change the dropdown list for size per page
    sizePerPage: 50, // which size per page you want to locate as default
    pageStartIndex: 1, // where to start counting the pages
    paginationSize: 1, // the pagination bar size.
    prePage: "Prev", // Previous page button text
    nextPage: "Next", // Next page button text
    firstPage: "First", // First page button text
    lastPage: "Last", // Last page button text
    paginationShowsTotal: true, // Accept bool or function
    paginationPosition: "bottom",
    // default is bottom, top and both is all available
    // hideSizePerPage: true > You can hide the dropdown for sizePerPage
    // alwaysShowAllBtns: true // Always show next and previous button
    withFirstAndLast: false,
    // Hide the going to First and Last page button

    // onRowClick: selectedValues,
  };
  function rowClassNameFormat(row, rowIdx) {
    // row is whole row object
    // rowIdx is index of row

    let tmpRisk = row.Risk;

    // production
    /*
  if (tmpRisk > 0 && tmpRisk < 499) {
    return "row-100-500"
  } 
  else if (tmpRisk > 500 && tmpRisk < 999) {
    return "row-500-1000"
  } 
  else if (tmpRisk > 1000 && tmpRisk < 2999) {
    return "row-1000-3000"
  } 
  else if (tmpRisk > 3000 && tmpRisk < 4999) {
    return "row-3000-5000"
  } 
  else  if (tmpRisk > 5) {
    return "row-5000"
  } 
  */
    if (tmpRisk > 0 && tmpRisk < 49) {
      return "row-100-500";
    } else if (tmpRisk > 50 && tmpRisk < 99) {
      return "row-500-1000";
    } else if (tmpRisk > 100 && tmpRisk < 199) {
      return "row-1000-3000";
    } else if (tmpRisk > 200 && tmpRisk < 500) {
      return "row-3000-5000";
    } else if (tmpRisk > 500) {
      return "row-5000";
    }

    // return rowIdx % 2 === 0 ? 'td-column-function-even-example' : 'td-column-function-odd-example';
  }

  function columnWidth() {
    return "column-width";
  }

  const isExpandableRow = (row) => {
    return true;
  };

  class BSTable extends React.Component {
    render() {
      if (this.props.data) {
        return (
          <div style={{ margin: "auto" }} className="text-xs border-t border-b">
            <table className="w-full bg-white">
              <tbody>
                <tr>
                  <td className="font-semibold border-r">Player:</td>
                  <td>{this.props.data.Player}</td>
                </tr>
                <tr>
                  <td className="font-semibold border-r">Date:</td>
                  <td>{this.props.data.PlacedDate}</td>
                </tr>
                <tr>
                  <td className="font-semibold border-r">Ticket:</td>
                  <td>{this.props.data.TicketNumber}</td>
                </tr>
                <tr>
                  <td className="font-semibold border-r">Description:</td>
                  <td>{this.props.data.Description}</td>
                </tr>
                <tr>
                  <td className="font-semibold border-r">User:</td>
                  <td>{this.props.data.User}</td>
                </tr>
                <tr>
                  <td className="font-semibold border-r">Risk/Win:</td>
                  <td>{this.props.data.Risk + " / " + this.props.data.Win}</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      } else {
        return <p>?</p>;
      }
    }
  }

  const expandComponent = (row) => {
    return <BSTable data={row} />;
  };

  return (
    <React.Fragment>
      {" "}
      {openBets && (
        <div className="open-bets">
          <br />
          <Table>
            <TableRow>
              <div className="mb-2">
                <h2>Color Codes:</h2>
                <div className="flex flex-row items-center justify-between w-full text-xs">
                  <span className="px-4 py-2 border-[1px] border-gray-300 rounded-xl row-100-500">
                    100-500
                  </span>
                  <span className="px-4 py-2 border-[1px] border-red-300 rounded-xl row-500-1000">
                    500-1000
                  </span>
                  <span className="px-4 py-2 border-[1px] border-red-500 rounded-xl row-1000-3000">
                    1000-3000
                  </span>
                  <span className="px-4 py-2 border-[1px] border-green-800 rounded-xl row-3000-5000">
                    3000-5000
                  </span>
                  <span className="px-4 py-2 border-[1px] border-pink-800 rounded-xl row-5000">
                    5000
                  </span>
                </div>
              </div>

              <BootstrapTable
                data={openBets}
                options={options}
                pagination={true}
                trClassName={rowClassNameFormat}
                version="4"
                expandableRow={isExpandableRow}
                expandComponent={expandComponent}
                hover
              >
                <TableHeaderColumn
                  dataField="Player"
                  filter={{
                    type: "TextFilter",
                    delay: 1000,
                  }}
                  width="120"
                >
                  Player
                </TableHeaderColumn>
                {/* 
                <TableHeaderColumn dataField="Agent"
                  filter={
                    {
                      type: 'TextFilter',
                      delay: 1000
                    }
                  }
                  width="130">
                  Agent
                                </TableHeaderColumn>
                <TableHeaderColumn hidden={true} isKey width="120" dataField="TicketNumber">
                  Ticket #
                                </TableHeaderColumn>
                <TableHeaderColumn dataField="PlacedDate">
                  Placed Date
                </TableHeaderColumn>
                */}

                <TableHeaderColumn
                  hidden={true}
                  isKey
                  width="120"
                  dataField="TicketNumber"
                >
                  Ticket #
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="WagerType"
                  filter={{
                    type: "TextFilter",
                    delay: 1000,
                  }}
                  width="260"
                >
                  Wager Type
                </TableHeaderColumn>

                <TableHeaderColumn dataField="Description">
                  Description
                </TableHeaderColumn>
                <TableHeaderColumn width="120" dataField="Risk">
                  Risk
                </TableHeaderColumn>
                <TableHeaderColumn width="120" dataField="Win">
                  Win
                </TableHeaderColumn>
                {/*
              	<TableHeaderColumn width="120" dataField="User">
									User
                </TableHeaderColumn>
                  */}
              </BootstrapTable>
            </TableRow>
          </Table>
        </div>
      )}{" "}
    </React.Fragment>
  );
}

export default OpenBets;
